import { getUniqueListBy } from '@utils/getUniqueListBy';

export type CountryParams = {
  prefix: number;
  country_code: string;
  display_name: string;
  mask: string;
};

export const Turkey = {
  prefix: 90 as const,
  country_code: 'TR' as const,
  display_name: 'Turkey',
  countryCode: 'TR' as const,
  displayName: 'Türkiye',
  id: 298,
  mask: '(000)000-00-00',
} as CountryParams;

const OLD_COUNTRIES = [
  {
    prefix: 93,
    country_code: 'AF',
    display_name: 'Afghanistan',
    mask: '00-000-0000',
  },
  {
    prefix: 358,
    country_code: 'AX',
    display_name: 'Åland Islands',
    mask: '(000)000-00-00',
  },
  {
    prefix: 355,
    country_code: 'AL',
    display_name: 'Albania',
    mask: '(000)000-000',
  },
  {
    prefix: 213,
    country_code: 'DZ',
    display_name: 'Algeria',
    mask: '00-000-0000',
  },
  {
    prefix: 1,
    country_code: 'AS',
    display_name: 'American Samoa',
    mask: '(684)000-0000',
  },
  {
    prefix: 376,
    country_code: 'AD',
    display_name: 'Andorra',
    mask: '000-000',
  },
  {
    prefix: 244,
    country_code: 'AO',
    display_name: 'Angola',
    mask: '(000)000-000',
  },
  {
    prefix: 1,
    country_code: 'AI',
    display_name: 'Anguilla',
    mask: '(264)000-0000',
  },
  {
    prefix: 1,
    country_code: 'AG',
    display_name: 'Antigua and Barbuda',
    mask: '(268)000-0000',
  },
  {
    prefix: 54,
    country_code: 'AR',
    display_name: 'Argentina',
    mask: '(000)000-0000',
  },
  {
    prefix: 374,
    country_code: 'AM',
    display_name: 'Armenia',
    mask: '00-000-000',
  },
  {
    prefix: 297,
    country_code: 'AW',
    display_name: 'Aruba',
    mask: '000-0000',
  },
  {
    prefix: 61,
    country_code: 'AU',
    display_name: 'Australia',
    mask: '0-0000-0000',
  },
  {
    prefix: 43,
    country_code: 'AT',
    display_name: 'Austria',
    mask: '(000)000-0000',
  },
  {
    prefix: 994,
    country_code: 'AZ',
    display_name: 'Azerbaijan',
    mask: '00-000-00-00',
  },
  {
    prefix: 1,
    country_code: 'BS',
    display_name: 'Bahamas',
    mask: '(242)000-0000',
  },
  {
    prefix: 973,
    country_code: 'BH',
    display_name: 'Bahrain',
    mask: '0000-0000',
  },
  {
    prefix: 880,
    country_code: 'BD',
    display_name: 'Bangladesh',
    mask: '1000-000000',
  },
  {
    prefix: 1,
    country_code: 'BB',
    display_name: 'Barbados',
    mask: '(246)000-0000',
  },
  {
    prefix: 375,
    country_code: 'BY',
    display_name: 'Belarus',
    mask: '(00)000-00-00',
  },
  {
    prefix: 32,
    country_code: 'BE',
    display_name: 'Belgium',
    mask: '(000)000-000',
  },
  {
    prefix: 501,
    country_code: 'BZ',
    display_name: 'Belize',
    mask: '000-0000',
  },
  {
    prefix: 229,
    country_code: 'BJ',
    display_name: 'Benin',
    mask: '00-00-0000',
  },
  {
    prefix: 1,
    country_code: 'BM',
    display_name: 'Bermuda',
    mask: '(441)000-0000',
  },
  {
    prefix: 975,
    country_code: 'BT',
    display_name: 'Bhutan',
    mask: ['17-000-000', '77-000-000', '0-000-000'],
  },
  {
    prefix: 591,
    country_code: 'BO',
    display_name: 'Bolivia',
    mask: '0-000-0000',
  },
  {
    prefix: 387,
    country_code: 'BA',
    display_name: 'Bosnia and Herzegovina',
    mask: ['00-0000', '00-00000'],
  },
  {
    prefix: 267,
    country_code: 'BW',
    display_name: 'Botswana',
    mask: '00-000-000',
  },
  {
    prefix: 55,
    country_code: 'BR',
    display_name: 'Brazil',
    mask: ['(00)0000-0000', '(00)00000-0000'],
  },
  {
    prefix: 246,
    country_code: 'IO',
    display_name: 'British Indian Ocean Territory',
    mask: '000-0000',
  },
  {
    prefix: 1,
    country_code: 'VG',
    display_name: 'British Virgin Islands',
    mask: '(284)000-0000',
  },
  {
    prefix: 673,
    country_code: 'BN',
    display_name: 'Brunei',
    mask: '000-0000',
  },
  {
    prefix: 359,
    country_code: 'BG',
    display_name: 'Bulgaria',
    mask: '(000)000-000',
  },
  {
    prefix: 226,
    country_code: 'BF',
    display_name: 'Burkina Faso',
    mask: '00-00-0000',
  },
  {
    prefix: 257,
    country_code: 'BI',
    display_name: 'Burundi',
    mask: '00-00-0000',
  },
  {
    prefix: 855,
    country_code: 'KH',
    display_name: 'Cambodia',
    mask: '00-000-000',
  },
  {
    prefix: 237,
    country_code: 'CM',
    display_name: 'Cameroon',
    mask: '0000-0000',
  },
  {
    prefix: 1,
    country_code: 'CA',
    display_name: 'Canada',
    mask: '(000)000-0000',
  },
  {
    prefix: 238,
    country_code: 'CV',
    display_name: 'Cape Verde',
    mask: '(000)00-00',
  },
  {
    prefix: 599,
    country_code: 'BQ',
    display_name: 'Caribbean Netherlands',
    mask: '',
  },
  {
    prefix: 1,
    country_code: 'KY',
    display_name: 'Cayman Islands',
    mask: '(345)000-0000',
  },
  {
    prefix: 236,
    country_code: 'CF',
    display_name: 'Central African Republic',
    mask: '00-00-0000',
  },
  {
    prefix: 235,
    country_code: 'TD',
    display_name: 'Chad',
    mask: '00-00-00-00',
  },
  {
    prefix: 56,
    country_code: 'CL',
    display_name: 'Chile',
    mask: '0-0000-0000',
  },
  {
    prefix: 86,
    country_code: 'CN',
    display_name: 'China',
    mask: ['(000)0000-000', '(000)0000-0000', '00-00000-00000'],
  },
  {
    prefix: 61,
    country_code: 'CX',
    display_name: 'Christmas Island',
    mask: '0-0000-0000',
  },
  {
    prefix: 61,
    country_code: 'CC',
    display_name: 'Cocos [Keeling] Islands',
    mask: '0-0000-0000',
  },
  {
    prefix: 57,
    country_code: 'CO',
    display_name: 'Colombia',
    mask: '(000)000-0000',
  },
  {
    prefix: 269,
    country_code: 'KM',
    display_name: 'Comoros',
    mask: '00-00000',
  },
  {
    prefix: 243,
    country_code: 'CD',
    display_name: 'Democratic Republic Congo',
    mask: '(000)000-000',
  },
  {
    prefix: 242,
    country_code: 'CG',
    display_name: 'Republic of Congo',
    mask: '00-00000',
  },
  {
    prefix: 682,
    country_code: 'CK',
    display_name: 'Cook Islands',
    mask: '00-000',
  },
  {
    prefix: 506,
    country_code: 'CR',
    display_name: 'Costa Rica',
    mask: '0000-0000',
  },
  {
    prefix: 225,
    country_code: 'CI',
    display_name: "Côte d'Ivoire",
    mask: '00-000-000',
  },
  {
    prefix: 385,
    country_code: 'HR',
    display_name: 'Croatia',
    mask: '00-000-000',
  },
  {
    prefix: 53,
    country_code: 'CU',
    display_name: 'Cuba',
    mask: '0-000-0000',
  },
  {
    prefix: 599,
    country_code: 'CW',
    display_name: 'Curaçao',
    mask: '',
  },
  {
    prefix: 357,
    country_code: 'CY',
    display_name: 'Cyprus',
    mask: '00-000-000',
  },
  {
    prefix: 420,
    country_code: 'CZ',
    display_name: 'Czech Republic',
    mask: '(000)000-000',
  },
  {
    prefix: 45,
    country_code: 'DK',
    display_name: 'Denmark',
    mask: '00-00-00-00',
  },
  {
    prefix: 253,
    country_code: 'DJ',
    display_name: 'Djibouti',
    mask: '00-00-00-00',
  },
  {
    prefix: 1,
    country_code: 'DM',
    display_name: 'Dominica',
    mask: '(767)000-0000',
  },
  {
    prefix: 1,
    country_code: 'DO',
    display_name: 'Dominican Republic',
    mask: ['(809)000-0000', '(829)000-0000', '(849)000-0000'],
  },
  {
    prefix: 670,
    country_code: 'TL',
    display_name: 'East Timor',
    mask: ['000-0000', '770-00000', '780-00000'],
  },
  {
    prefix: 593,
    country_code: 'EC',
    display_name: 'Ecuador',
    mask: ['0-000-0000', '00-000-0000'],
  },
  {
    prefix: 20,
    country_code: 'EG',
    display_name: 'Egypt',
    mask: '(000)000-0000',
  },
  {
    prefix: 503,
    country_code: 'SV',
    display_name: 'El Salvador',
    mask: '00-00-0000',
  },
  {
    prefix: 240,
    country_code: 'GQ',
    display_name: 'Equatorial Guinea',
    mask: '00-000-0000',
  },
  {
    prefix: 291,
    country_code: 'ER',
    display_name: 'Eritrea',
    mask: '0-000-000',
  },
  {
    prefix: 372,
    country_code: 'EE',
    display_name: 'Estonia',
    mask: ['000-0000', '0000-0000'],
  },
  {
    prefix: 251,
    country_code: 'ET',
    display_name: 'Ethiopia',
    mask: '00-000-0000',
  },
  {
    prefix: 500,
    country_code: 'FK',
    display_name: 'Falkland Islands [Islas Malvinas]',
    mask: '00000',
  },
  {
    prefix: 298,
    country_code: 'FO',
    display_name: 'Faroe Islands',
    mask: '000-000',
  },
  {
    prefix: 679,
    country_code: 'FJ',
    display_name: 'Fiji',
    mask: '00-00000',
  },
  {
    prefix: 358,
    country_code: 'FI',
    display_name: 'Finland',
    mask: '(000)000-00-00',
  },
  {
    prefix: 33,
    country_code: 'FR',
    display_name: 'France',
    mask: '(000)000-000',
  },
  {
    prefix: 594,
    country_code: 'GF',
    display_name: 'French Guiana',
    mask: '00000-0000',
  },
  {
    prefix: 689,
    country_code: 'PF',
    display_name: 'French Polynesia',
    mask: '00-00-00',
  },
  {
    prefix: 241,
    country_code: 'GA',
    display_name: 'Gabon',
    mask: '0-00-00-00',
  },
  {
    prefix: 220,
    country_code: 'GM',
    display_name: 'Gambia',
    mask: '(000)00-00',
  },
  {
    prefix: 995,
    country_code: 'GE',
    display_name: 'Georgia',
    mask: '(000)000-000',
  },
  {
    prefix: 49,
    country_code: 'DE',
    display_name: 'Germany',
    mask: [
      '000-000',
      '(000)00-00',
      '(000)00-000',
      '(000)00-0000',
      '(000)000-0000',
      '(0000)000-0000',
    ],
  },
  {
    prefix: 233,
    country_code: 'GH',
    display_name: 'Ghana',
    mask: '(000)000-000',
  },
  {
    prefix: 350,
    country_code: 'GI',
    display_name: 'Gibraltar',
    mask: '000-00000',
  },
  {
    prefix: 30,
    country_code: 'GR',
    display_name: 'Greece',
    mask: '(000)000-0000',
  },
  {
    prefix: 299,
    country_code: 'GL',
    display_name: 'Greenland',
    mask: '00-00-00',
  },
  {
    prefix: 1,
    country_code: 'GD',
    display_name: 'Grenada',
    mask: '(473)000-0000',
  },
  {
    prefix: 590,
    country_code: 'GP',
    display_name: 'Guadeloupe',
    mask: '(000)000-000',
  },
  {
    prefix: 1,
    country_code: 'GU',
    display_name: 'Guam',
    mask: '(671)000-0000',
  },
  {
    prefix: 502,
    country_code: 'GT',
    display_name: 'Guatemala',
    mask: '0-000-0000',
  },
  {
    prefix: 44,
    country_code: 'GG',
    display_name: 'Guernsey',
    mask: '(0000)000000',
  },
  {
    prefix: 224,
    country_code: 'GN',
    display_name: 'Guinea Conakry',
    mask: '00-000-000',
  },
  {
    prefix: 245,
    country_code: 'GW',
    display_name: 'Guinea-Bissau',
    mask: '0-000000',
  },
  {
    prefix: 592,
    country_code: 'GY',
    display_name: 'Guyana',
    mask: '000-0000',
  },
  {
    prefix: 509,
    country_code: 'HT',
    display_name: 'Haiti',
    mask: '00-00-0000',
  },
  {
    prefix: 672,
    country_code: 'HM',
    display_name: 'Heard Island and McDonald Islands',
    mask: '',
  },
  {
    prefix: 504,
    country_code: 'HN',
    display_name: 'Honduras',
    mask: '0000-0000',
  },
  {
    prefix: 852,
    country_code: 'HK',
    display_name: 'Hong Kong',
    mask: '0000-0000',
  },
  {
    prefix: 36,
    country_code: 'HU',
    display_name: 'Hungary',
    mask: '(000)000-000',
  },
  {
    prefix: 354,
    country_code: 'IS',
    display_name: 'Iceland',
    mask: '000-0000',
  },
  {
    prefix: 91,
    country_code: 'IN',
    display_name: 'India',
    mask: '(0000)000-000',
  },
  {
    prefix: 62,
    country_code: 'ID',
    display_name: 'Indonesia',
    mask: [
      '00-000-00',
      '00-000-000',
      '00-000-0000',
      '(800)000-000',
      '(800)000-00-000',
    ],
  },
  {
    prefix: 98,
    country_code: 'IR',
    display_name: 'Iran',
    mask: '(000)000-0000',
  },
  {
    prefix: 964,
    country_code: 'IQ',
    display_name: 'Iraq',
    mask: '(000)000-0000',
  },
  {
    prefix: 353,
    country_code: 'IE',
    display_name: 'Ireland',
    mask: '(000)000-000',
  },
  {
    prefix: 44,
    country_code: 'IM',
    display_name: 'Isle of Man',
    mask: '(0000)000000',
  },
  {
    prefix: 972,
    country_code: 'IL',
    display_name: 'Israel',
    mask: ['0-000-0000', '50-000-0000'],
  },
  {
    prefix: 39,
    country_code: 'IT',
    display_name: 'Italy',
    mask: '(000)0000-000',
  },
  {
    prefix: 1,
    country_code: 'JM',
    display_name: 'Jamaica',
    mask: '(876)000-0000',
  },
  {
    prefix: 81,
    country_code: 'JP',
    display_name: 'Japan',
    mask: ['(000)000-000', '00-0000-0000'],
  },
  {
    prefix: 44,
    country_code: 'JE',
    display_name: 'Jersey',
    mask: '(0000)0000-000000',
  },
  {
    prefix: 962,
    country_code: 'JO',
    display_name: 'Jordan',
    mask: '0-0000-0000',
  },
  {
    prefix: 7,
    country_code: 'KZ',
    display_name: 'Kazakhstan',
    mask: ['(600)000-00-00', '(700)000-00-00'],
  },
  {
    prefix: 254,
    country_code: 'KE',
    display_name: 'Kenya',
    mask: '000-000000',
  },
  {
    prefix: 686,
    country_code: 'KI',
    display_name: 'Kiribati',
    mask: '00-000',
  },
  {
    prefix: 965,
    country_code: 'KW',
    display_name: 'Kuwait',
    mask: '0000-0000',
  },
  {
    prefix: 996,
    country_code: 'KG',
    display_name: 'Kyrgyzstan',
    mask: '(000)000-000',
  },
  {
    prefix: 856,
    country_code: 'LA',
    display_name: 'Laos',
    mask: ['00-000-000', '(2000)000-000'],
  },
  {
    prefix: 371,
    country_code: 'LV',
    display_name: 'Latvia',
    mask: '00-000-000',
  },
  {
    prefix: 961,
    country_code: 'LB',
    display_name: 'Lebanon',
    mask: ['0-000-000', '00-000-000'],
  },
  {
    prefix: 266,
    country_code: 'LS',
    display_name: 'Lesotho',
    mask: '0-000-0000',
  },
  {
    prefix: 231,
    country_code: 'LR',
    display_name: 'Liberia',
    mask: '00-000-000',
  },
  {
    prefix: 218,
    country_code: 'LY',
    display_name: 'Libya',
    mask: ['00-000-000', '21-000-0000'],
  },
  {
    prefix: 423,
    country_code: 'LI',
    display_name: 'Liechtenstein',
    mask: '(000)000-0000',
  },
  {
    prefix: 370,
    country_code: 'LT',
    display_name: 'Lithuania',
    mask: '(000)00-000',
  },
  {
    prefix: 352,
    country_code: 'LU',
    display_name: 'Luxembourg',
    mask: '(000)000-000',
  },
  {
    prefix: 853,
    country_code: 'MO',
    display_name: 'Macau',
    mask: '0000-0000',
  },
  {
    prefix: 389,
    country_code: 'MK',
    display_name: 'Macedonia',
    mask: '00-000-000',
  },
  {
    prefix: 261,
    country_code: 'MG',
    display_name: 'Madagascar',
    mask: '00-00-00000',
  },
  {
    prefix: 265,
    country_code: 'MW',
    display_name: 'Malawi',
    mask: ['1-000-000', '0-0000-0000'],
  },
  {
    prefix: 60,
    country_code: 'MY',
    display_name: 'Malaysia',
    mask: ['0-000-000', '00-000-000', '(000)000-000', '00-000-0000'],
  },
  {
    prefix: 960,
    country_code: 'MV',
    display_name: 'Maldives',
    mask: '000-0000',
  },
  {
    prefix: 223,
    country_code: 'ML',
    display_name: 'Mali',
    mask: '00-00-0000',
  },
  {
    prefix: 356,
    country_code: 'MT',
    display_name: 'Malta',
    mask: '0000-0000',
  },
  {
    prefix: 692,
    country_code: 'MH',
    display_name: 'Marshall Islands',
    mask: '000-0000',
  },
  {
    prefix: 596,
    country_code: 'MQ',
    display_name: 'Martinique',
    mask: '(000)00-00-00',
  },
  {
    prefix: 222,
    country_code: 'MR',
    display_name: 'Mauritania',
    mask: '00-00-0000',
  },
  {
    prefix: 230,
    country_code: 'MU',
    display_name: 'Mauritius',
    mask: '000-0000',
  },
  {
    prefix: 262,
    country_code: 'YT',
    display_name: 'Mayotte',
    mask: '00000-0000',
  },
  {
    prefix: 52,
    country_code: 'MX',
    display_name: 'Mexico',
    mask: ['00-00-0000', '(000)000-0000'],
  },
  {
    prefix: 691,
    country_code: 'FM',
    display_name: 'Micronesia',
    mask: '000-0000',
  },
  {
    prefix: 373,
    country_code: 'MD',
    display_name: 'Moldova',
    mask: '0000-0000',
  },
  {
    prefix: 377,
    country_code: 'MC',
    display_name: 'Monaco',
    mask: ['00-000-000', '(000)000-000'],
  },
  {
    prefix: 976,
    country_code: 'MN',
    display_name: 'Mongolia',
    mask: '00-00-0000',
  },
  {
    prefix: 382,
    country_code: 'ME',
    display_name: 'Montenegro',
    mask: '00-000-000',
  },
  {
    prefix: 1,
    country_code: 'MS',
    display_name: 'Montserrat',
    mask: '(664)000-0000',
  },
  {
    prefix: 212,
    country_code: 'MA',
    display_name: 'Morocco',
    mask: '00-0000-000',
  },
  {
    prefix: 258,
    country_code: 'MZ',
    display_name: 'Mozambique',
    mask: '00-000-000',
  },
  {
    prefix: 95,
    country_code: 'MM',
    display_name: 'Myanmar [Burma]',
    mask: ['000-000', '0-000-000', '00-000-000'],
  },
  {
    prefix: 264,
    country_code: 'NA',
    display_name: 'Namibia',
    mask: '00-000-0000',
  },
  {
    prefix: 674,
    country_code: 'NR',
    display_name: 'Nauru',
    mask: '000-0000',
  },
  {
    prefix: 977,
    country_code: 'NP',
    display_name: 'Nepal',
    mask: '00-000-000',
  },
  {
    prefix: 31,
    country_code: 'NL',
    display_name: 'Netherlands',
    mask: '00-000-0000',
  },
  {
    prefix: 687,
    country_code: 'NC',
    display_name: 'New Caledonia',
    mask: '00-0000',
  },
  {
    prefix: 64,
    country_code: 'NZ',
    display_name: 'New Zealand',
    mask: ['0-000-000', '(000)000-000', '(000)000-0000'],
  },
  {
    prefix: 505,
    country_code: 'NI',
    display_name: 'Nicaragua',
    mask: '0000-0000',
  },
  {
    prefix: 227,
    country_code: 'NE',
    display_name: 'Niger',
    mask: '00-00-0000',
  },
  {
    prefix: 234,
    country_code: 'NG',
    display_name: 'Nigeria',
    mask: ['00-000-00', '00-000-000', '(000)000-0000'],
  },
  {
    prefix: 683,
    country_code: 'NU',
    display_name: 'Niue',
    mask: '0000',
  },
  {
    prefix: 672,
    country_code: 'NF',
    display_name: 'Norfolk Island',
    mask: '300-000',
  },
  {
    prefix: 850,
    country_code: 'KP',
    display_name: 'North Korea',
    mask: [
      '000-000',
      '0000-0000',
      '00-000-000',
      '000-0000-000',
      '191-000-0000',
      '0000-0000000000000',
    ],
  },
  {
    prefix: 1,
    country_code: 'MP',
    display_name: 'Northern Mariana Islands',
    mask: '(670)000-0000',
  },
  {
    prefix: 47,
    country_code: 'NO',
    display_name: 'Norway',
    mask: '(000)00-000',
  },
  {
    prefix: 968,
    country_code: 'OM',
    display_name: 'Oman',
    mask: '00-000-000',
  },
  {
    prefix: 92,
    country_code: 'PK',
    display_name: 'Pakistan',
    mask: '(000)000-0000',
  },
  {
    prefix: 680,
    country_code: 'PW',
    display_name: 'Palau',
    mask: '000-0000',
  },
  {
    prefix: 970,
    country_code: 'PS',
    display_name: 'Palestinian Territories',
    mask: '00-000-0000',
  },
  {
    prefix: 507,
    country_code: 'PA',
    display_name: 'Panama',
    mask: '000-0000',
  },
  {
    prefix: 675,
    country_code: 'PG',
    display_name: 'Papua New Guinea',
    mask: '(000)00-000',
  },
  {
    prefix: 595,
    country_code: 'PY',
    display_name: 'Paraguay',
    mask: '(000)000-000',
  },
  {
    prefix: 51,
    country_code: 'PE',
    display_name: 'Peru',
    mask: '(000)000-000',
  },
  {
    prefix: 63,
    country_code: 'PH',
    display_name: 'Philippines',
    mask: '(000)000-0000',
  },
  {
    prefix: 48,
    country_code: 'PL',
    display_name: 'Poland',
    mask: '(000)000-000',
  },
  {
    prefix: 351,
    country_code: 'PT',
    display_name: 'Portugal',
    mask: '00-000-0000',
  },
  {
    prefix: 1,
    country_code: 'PR',
    display_name: 'Puerto Rico',
    mask: ['(787) 000 0000', '(939) 000 0000'],
  },
  {
    prefix: 974,
    country_code: 'QA',
    display_name: 'Qatar',
    mask: '0000-0000',
  },
  {
    prefix: 262,
    country_code: 'RE',
    display_name: 'Réunion',
    mask: '00000-0000',
  },
  {
    prefix: 40,
    country_code: 'RO',
    display_name: 'Romania',
    mask: '00-000-0000',
  },
  {
    prefix: 7,
    country_code: 'RU',
    display_name: 'Russia',
    mask: '(000)000-00-00',
  },
  {
    prefix: 250,
    country_code: 'RW',
    display_name: 'Rwanda',
    mask: '(000)000-000',
  },
  {
    prefix: 590,
    country_code: 'BL',
    display_name: 'Saint Barthélemy',
    mask: '000-00-00-00',
  },
  {
    prefix: 290,
    country_code: 'SH',
    display_name: 'Saint Helena',
    mask: '0000',
  },
  {
    prefix: 1,
    country_code: 'KN',
    display_name: 'St. Kitts',
    mask: '(869)000-0000',
  },
  {
    prefix: 1,
    country_code: 'LC',
    display_name: 'St. Lucia',
    mask: '(758)000-0000',
  },
  {
    prefix: 590,
    country_code: 'MF',
    display_name: 'Saint Martin',
    mask: '(000)000-000',
  },
  {
    prefix: 508,
    country_code: 'PM',
    display_name: 'Saint Pierre and Miquelon',
    mask: '00-0000',
  },
  {
    prefix: 1,
    country_code: 'VC',
    display_name: 'St. Vincent',
    mask: '(784)000-0000',
  },
  {
    prefix: 685,
    country_code: 'WS',
    display_name: 'Samoa',
    mask: '00-0000',
  },
  {
    prefix: 378,
    country_code: 'SM',
    display_name: 'San Marino',
    mask: '0000-000000',
  },
  {
    prefix: 239,
    country_code: 'ST',
    display_name: 'São Tomé and Príncipe',
    mask: '00-00000',
  },
  {
    prefix: 966,
    country_code: 'SA',
    display_name: 'Saudi Arabia',
    mask: ['0-000-0000', '50-0000-0000'],
  },
  {
    prefix: 221,
    country_code: 'SN',
    display_name: 'Senegal',
    mask: '00-000-0000',
  },
  {
    prefix: 381,
    country_code: 'RS',
    display_name: 'Serbia',
    mask: '00-000-0000',
  },
  {
    prefix: 248,
    country_code: 'SC',
    display_name: 'Seychelles',
    mask: '0-000-000',
  },
  {
    prefix: 232,
    country_code: 'SL',
    display_name: 'Sierra Leone',
    mask: '00-000000',
  },
  {
    prefix: 65,
    country_code: 'SG',
    display_name: 'Singapore',
    mask: '0000-0000',
  },
  {
    prefix: 1,
    country_code: 'SX',
    display_name: 'Sint Maarten',
    mask: '(721)000-0000',
  },
  {
    prefix: 421,
    country_code: 'SK',
    display_name: 'Slovakia',
    mask: '(000)000-000',
  },
  {
    prefix: 386,
    country_code: 'SI',
    display_name: 'Slovenia',
    mask: '00-000-000',
  },
  {
    prefix: 677,
    country_code: 'SB',
    display_name: 'Solomon Islands',
    mask: ['00000', '000-0000'],
  },
  {
    prefix: 252,
    country_code: 'SO',
    display_name: 'Somalia',
    mask: ['0-000-000', '00-000-000'],
  },
  {
    prefix: 27,
    country_code: 'ZA',
    display_name: 'South Africa',
    mask: '00-000-0000',
  },
  {
    prefix: 500,
    country_code: 'GS',
    display_name: 'South Georgia and the South Sandwich Islands',
    mask: '00000',
  },
  {
    prefix: 82,
    country_code: 'KR',
    display_name: 'South Korea',
    mask: '00-000-0000',
  },
  {
    prefix: 211,
    country_code: 'SS',
    display_name: 'South Sudan',
    mask: '00-000-0000',
  },
  {
    prefix: 34,
    country_code: 'ES',
    display_name: 'Spain',
    mask: '(000)000-000',
  },
  {
    prefix: 94,
    country_code: 'LK',
    display_name: 'Sri Lanka',
    mask: '00-000-0000',
  },
  {
    prefix: 249,
    country_code: 'SD',
    display_name: 'Sudan',
    mask: '00-000-0000',
  },
  {
    prefix: 597,
    country_code: 'SR',
    display_name: 'Suriname',
    mask: ['000-000', '000-0000'],
  },
  {
    prefix: 47,
    country_code: 'SJ',
    display_name: 'Svalbard and Jan Mayen',
    mask: '(000)00-000',
  },
  {
    prefix: 268,
    country_code: 'SZ',
    display_name: 'Swaziland',
    mask: '00-00-0000',
  },
  {
    prefix: 46,
    country_code: 'SE',
    display_name: 'Sweden',
    mask: '00-000-0000',
  },
  {
    prefix: 41,
    country_code: 'CH',
    display_name: 'Switzerland',
    mask: '00-000-0000',
  },
  {
    prefix: 963,
    country_code: 'SY',
    display_name: 'Syria',
    mask: '00-0000-000',
  },
  {
    prefix: 886,
    country_code: 'TW',
    display_name: 'Taiwan',
    mask: ['0000-0000', '0-0000-0000'],
  },
  {
    prefix: 992,
    country_code: 'TJ',
    display_name: 'Tajikistan',
    mask: '00-000-0000',
  },
  {
    prefix: 255,
    country_code: 'TZ',
    display_name: 'Tanzania',
    mask: '00-000-0000',
  },
  {
    prefix: 66,
    country_code: 'TH',
    display_name: 'Thailand',
    mask: ['00-000-000', '00-000-0000'],
  },
  {
    prefix: 228,
    country_code: 'TG',
    display_name: 'Togo',
    mask: '00-000-000',
  },
  {
    prefix: 690,
    country_code: 'TK',
    display_name: 'Tokelau',
    mask: '0000',
  },
  {
    prefix: 676,
    country_code: 'TO',
    display_name: 'Tonga',
    mask: '00000',
  },
  {
    prefix: 1,
    country_code: 'TT',
    display_name: 'Trinidad/Tobago',
    mask: '(868)000-0000',
  },
  {
    prefix: 216,
    country_code: 'TN',
    display_name: 'Tunisia',
    mask: '00-000-000',
  },
  {
    prefix: 90,
    country_code: 'TR',
    display_name: 'Turkey',
    countryCode: 'TR',
    displayName: 'Türkiye',
    id: 298,
    mask: '(000)000-00-00',
  },
  {
    prefix: 993,
    country_code: 'TM',
    display_name: 'Turkmenistan',
    mask: '0-000-0000',
  },
  {
    prefix: 1,
    country_code: 'TC',
    display_name: 'Turks and Caicos Islands',
    mask: '(249)000-000',
  },
  {
    prefix: 688,
    country_code: 'TV',
    display_name: 'Tuvalu',
    mask: ['20000', '900000'],
  },
  {
    prefix: 1,
    country_code: 'VI',
    display_name: 'U.S. Virgin Islands',
    mask: '(340)000-0000',
  },
  {
    prefix: 256,
    country_code: 'UG',
    display_name: 'Uganda',
    mask: '(000)000-000',
  },
  {
    prefix: 380,
    country_code: 'UA',
    display_name: 'Ukraine',
    mask: '(00)000-00-00',
  },
  {
    prefix: 971,
    country_code: 'AE',
    display_name: 'United Arab Emirates',
    mask: ['0-000-0000', '50-000-0000'],
  },
  {
    prefix: 44,
    country_code: 'GB',
    display_name: 'United Kingdom',
    mask: '00-0000-0000',
  },
  {
    prefix: 1,
    country_code: 'US',
    display_name: 'United States',
    mask: '(000)000-0000',
  },
  {
    prefix: 598,
    country_code: 'UY',
    display_name: 'Uruguay',
    mask: '0-000-00-00',
  },
  {
    prefix: 998,
    country_code: 'UZ',
    display_name: 'Uzbekistan',
    mask: '00-000-0000',
  },
  {
    prefix: 678,
    country_code: 'VU',
    display_name: 'Vanuatu',
    mask: ['00000', '00-00000'],
  },
  {
    prefix: 379,
    country_code: 'VA',
    display_name: 'Vatican City',
    mask: '06 69800000',
  },
  {
    prefix: 58,
    country_code: 'VE',
    display_name: 'Venezuela',
    mask: '(000)000-0000',
  },
  {
    prefix: 84,
    country_code: 'VN',
    display_name: 'Vietnam',
    mask: ['00-0000-000', '(000)0000-000'],
  },
  {
    prefix: 681,
    country_code: 'WF',
    display_name: 'Wallis and Futuna',
    mask: '00-0000',
  },
  {
    prefix: 212,
    country_code: 'EH',
    display_name: 'Western Sahara',
    mask: '',
  },
  {
    prefix: 967,
    country_code: 'YE',
    display_name: 'Yemen',
    mask: ['0-000-000', '00-000-000', '000-000-000'],
  },
  {
    prefix: 260,
    country_code: 'ZM',
    display_name: 'Zambia',
    mask: '00-000-0000',
  },
  {
    prefix: 263,
    country_code: 'ZW',
    display_name: 'Zimbabwe',
    mask: '0-000000',
  },
].map((x) => ({
  ...x,
  countryCode: x.country_code,
  displayName: x.display_name,
  id: 0,
}));

export const COUNTRIES = getUniqueListBy(OLD_COUNTRIES, 'prefix');

export default COUNTRIES;

export const COUNTRIES_NAMES = COUNTRIES.map((c) => c.display_name);
